import React from 'react';
import { Helmet } from 'react-helmet-async';

const DOMAIN = 'https://www.ringez.com';

const SEO = ({
    title,
    description,
    canonical,
    ogImage = '/og-image.png',
    ogType = 'website',
    schema
}) => {
    // Construct absolute URLs
    const siteUrl = DOMAIN;
    const fullCanonical = canonical ? (canonical.startsWith('http') ? canonical : `${siteUrl}${canonical}`) : window.location.href;
    const fullOgImage = ogImage.startsWith('http') ? ogImage : `${siteUrl}${ogImage}`;

    const defaultDescription = "Make private international calls instantly from your browser. No account, no phone number required. Secure calling to 200+ countries.";
    const metaDescription = description || defaultDescription;
    const fullTitle = title ? `${title} | Ringez` : "Ringez - Private International Calling";

    return (
        <Helmet>
            {/* Standard Meta Tags */}
            <title>{fullTitle}</title>
            <meta name="description" content={metaDescription} />
            <link rel="canonical" href={fullCanonical} />

            {/* Open Graph Tags */}
            <meta property="og:title" content={fullTitle} />
            <meta property="og:description" content={metaDescription} />
            <meta property="og:image" content={fullOgImage} />
            <meta property="og:url" content={fullCanonical} />
            <meta property="og:type" content={ogType} />
            <meta property="og:site_name" content="Ringez" />

            {/* Twitter Card Tags */}
            <meta name="twitter:card" content="summary_large_image" />
            <meta name="twitter:title" content={fullTitle} />
            <meta name="twitter:description" content={metaDescription} />
            <meta name="twitter:image" content={fullOgImage} />

            {/* Schema Markup */}
            {schema && (
                <script type="application/ld+json">
                    {JSON.stringify(schema)}
                </script>
            )}
        </Helmet>
    );
};

export default SEO;
